import React from 'react';
import './GuessedLetters.css';

interface GuessedLettersProps {
  guessedLetters: string[];
  secretWord: string;
  autoRevealedLetters: string[];
  visible: boolean;
}

const GuessedLetters: React.FC<GuessedLettersProps> = ({
  guessedLetters,
  secretWord,
  autoRevealedLetters,
  visible
}) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="guesses-section">
      <div className="previous-guesses">
        <h4>Guessed Letters:</h4>
        <div className="letter-list">
          {guessedLetters.map((letter, index) => (
            <span 
              key={index} 
              className={`guessed-letter 
                ${secretWord.includes(letter) ? 'correct' : ''} 
                ${autoRevealedLetters.includes(letter) ? 'auto-revealed' : ''}`}
            >
              {letter}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GuessedLetters;
